import GenericAction from "@Actions/generic-action";
import { Actions, Events } from "@Context/common/general/context";
import { AnalyticsEvents } from "@Enums";
import * as Sentry from "@sentry/react";
import { getAuth } from "firebase/auth";
export default class Auth extends GenericAction {
  handleUserDoesNotExist(errorMessage) {
    // Clear amp & sentry data
    // this._amplitude.clearUserProperties();
    Sentry.setUser(null);

    // Send unauth analytics event
    this._dispatch({
      type: Actions.AppActions.AnalyticsEvent,
      payload: { type: AnalyticsEvents.user_unauthenicated },
    });

    // Set initialized for app state regardless of auth state (needed for proper bridge handling)
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        app: {
          initialized: true,
        },
        auth: {
          errorMessage: errorMessage || "",
        },
      },
    });
    this._dispatch({
      type: Actions.CoreActions.Reset,
    });

    Events.auth.logout.emit();
  }

  runAction() {
    this._disableLoaders = true;

    // Update Auth state always on firebase auth state changes
    const Action = async () => {
      try {
        getAuth().onAuthStateChanged((user) => {
          if (user) { 
            this._dispatch({
              type: Actions.CoreActions.UpdateState,
              payload: {
                user: {
                  emailVerified: user.emailVerified,
                }
              },
            });
            this._state.auth.events.authStateChanged.emit(user);

            // Trigger update user account info immediately after auth
            this._dispatch({
              type: Actions.UsersActions.GetAccountInfo,
              onSuccess: () => {
                this._dispatch({
                  type: Actions.CoreActions.UpdateState,
                  payload: {
                    auth: {
                      errorMessage: "",
                    }
                  },
                });
              },
              onError: () => {
                this.handleUserDoesNotExist(`A Be Your Best user does not exist for ${user.email}`);
              },
            });

            this._dispatch({
              type: Actions.AppActions.AnalyticsEvent,
              payload: { type: AnalyticsEvents.user_authenicated },
            });

            Events.auth.loginSuccess.emit();
          } else {
            this.handleUserDoesNotExist();
          }
        });
        super.onSuccess();
        return Promise.resolve();
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}
